module.exports = __webpack_public_path__ + "static/media/arrow-up.ffc4cab8.svg";